module.exports = __webpack_public_path__ + "media/images/flags/VU-72288a1091e4a239017388e5ec0b6935.svg";